import { create } from 'zustand';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { persist } from 'zustand/middleware';

export const useSubscriptionStore = create()(
    persist(
        (set) => ({
            refetchSubscriptions: false,
            storeRefetchSubscriptions: (refetchSubscriptions) => set(() => ({ refetchSubscriptions: refetchSubscriptions })),
            query: getInitialQuery(),
            storeQuery: (query) => set(() => ({ query: query })),

            queryPayluddSubscriptions: getInitialQuery(),
            storeQueryPayluddSubscriptions: (queryPayluddSubscriptions) => set(() => ({ queryPayluddSubscriptions: queryPayluddSubscriptions }))
        }),
        {
            name: 'subscription-storage'
        }
    )
);

export default useSubscriptionStore;